import {
	forwardRef,
	type AnchorHTMLAttributes,
	type ButtonHTMLAttributes,
} from "react";

import { cn } from "@babybjorn/ui";
import * as s from "./Tab.module.scss";

type TabProps = ButtonHTMLAttributes<HTMLButtonElement> &
	AnchorHTMLAttributes<HTMLAnchorElement> & {
		label: string;
		className?: string;
		index: number;
		active?: boolean;
		anchorTag?: boolean;
		href?: string;
	};

const Tab = forwardRef<HTMLLIElement, TabProps>(
	({ active, label, anchorTag, href, ...rest }, ref) => {
		return (
			<li ref={ref} className={cn(s.tabItem)}>
				{anchorTag ? (
					<a
						href={href ?? ""}
						id={`Tab ${label}`}
						className={cn(s.tab, {
							[s.anchorTag]: anchorTag,
							[s.active]: active,
						})}
						{...rest}
					>
						{label}
					</a>
				) : (
					<button
						id={`Tab ${label}`}
						className={cn(s.tab, {
							[s.active]: active,
						})}
						{...rest}
					>
						{label}
					</button>
				)}
			</li>
		);
	},
);

Tab.displayName = "Tab";

export default Tab;
